import styled from "styled-components";
import { FormInstance } from "antd";
import { SearchBarType } from "../../constant/SearchBarType";
import { DatePicker, Select, Form, Input, Button } from "@renderbus/ui";
import SearchIcon from "@/assets/icons/invoice/search";
import { useTranslation } from "react-i18next";

export interface SearchBarProps {
  searchConfig: {
    type: string;
    label: string;
    field: string;
    commponentProps?: any;
  }[];
  searchForm: FormInstance;
  showButtonIcon?: boolean;
  onSearch: () => void;
}

export default function SearchBar({
  searchConfig,
  searchForm,
  showButtonIcon,
  onSearch,
}: SearchBarProps) {
  const { t } = useTranslation("common");
  return (
    <SearchWrapper>
      {searchConfig.map((item, i) => (
        <Form form={searchForm} layout="inline" colon={false} key={i}>
          <Form.Item key={item.field} name={item.field} label={item.label}>
            {(() => {
              switch (item.type) {
                case SearchBarType.DatePicker:
                  return (
                    <DatePicker {...item.commponentProps} size={"middle"} />
                  );
                case SearchBarType.Input:
                  return (
                    <Input
                      {...item.commponentProps}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          onSearch();
                        }
                      }}
                    />
                  );
                case SearchBarType.Select:
                  return <Select {...item.commponentProps} />;
                default:
                  return null;
              }
            })()}
          </Form.Item>
        </Form>
      ))}
      <Button onClick={onSearch}>
        {showButtonIcon ? <SearchIcon /> : t("search_btn_text")}
      </Button>
    </SearchWrapper>
  );
}

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  .ant-picker-input input {
    font-size: 14px;
  }
`;
